export const FIGMA_INPUT_CLASS = [
  'w-full', 'h-[54px]', 'rounded-[999px]', 'border',
  'border-[var(--figma-border-10)]', 'bg-[var(--figma-surface-05)]',
  'px-4', 'text-[16px]', 'font-[400]', 'leading-[22px]',
  'tracking-[-0.01em]', 'text-[var(--figma-text)]', 'outline-none',
  'placeholder:text-[var(--figma-text-50)]', 'transition-colors',
  'duration-[160ms]', 'focus:border-[var(--figma-border-10)]', 'focus:outline-none', 'focus:ring-0',
].join(' ')

export const FIGMA_INPUT_SHELL_CLASS = [
  'relative', 'flex', 'h-[54px]', 'w-full', 'items-center',
  'overflow-hidden', 'rounded-[999px]', 'border', 'border-[var(--figma-border-10)]',
  'bg-[var(--figma-surface-05)]', 'transition-colors',
  'duration-[160ms]',
].join(' ')
